import { EAppActionTypes, IAppStoreAction } from '../actions'
import { IToursCategoriesValue } from '../types';

export default (state: IToursCategoriesValue, { type, selectedTopCategory, selectedCategories}: IAppStoreAction) => {
	switch (type) {
		case EAppActionTypes.SetSelectedTopCategory:
			if (!selectedTopCategory) return state
            if (selectedTopCategory && state.selectedTopCategory && selectedTopCategory.name === state.selectedTopCategory.name) return state
            return { selectedTopCategory, selectedCategories: selectedTopCategory.categories }
		case EAppActionTypes.SetSelectedCategories:
            if (selectedCategories)
				return { ...state, selectedCategories }
		default:
			return state
	}
}